import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

interface StoryDetailData {
  id: string;
  title: string;
  category: string;
  date: string;
  authorName: string;
  authorAvatar: string;
  coverImage: string;
  duration: string;
  views: number;
  hearts: number;
  transcript: string;
  familyGroup: string;
}

@Component({
  selector: 'app-story-detail',
  templateUrl: './story-detail.html',
  styleUrl: './story-detail.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class StoryDetail implements OnInit {
  private route = inject(ActivatedRoute);
  private location = inject(Location);

  readonly story = signal<StoryDetailData | null>(null);
  readonly isPlaying = signal(false);
  readonly transcriptOpen = signal(true);
  readonly isLiked = signal(false);

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id') ?? '1';
    this.story.set({
      id,
      title: 'The Day I Started My First Job',
      category: 'Career & Work',
      date: 'June 12, 2025',
      authorName: 'Robert K.',
      authorAvatar: 'images/homepage/avatar-2.png',
      coverImage: 'images/stories/story-cover-1.png',
      duration: '2:34',
      views: 128,
      hearts: 34,
      familyGroup: 'Johnson Family',
      transcript: 'It was a rainy Monday morning when I walked into the office for the very first time. I was nervous but excited. I remember how the receptionist greeted me warmly and showed me to my desk. That day taught me so much about professionalism, patience, and believing in myself. I still think about those early days whenever I face a new challenge at work.',
    });
  }

  goBack(): void { this.location.back(); }
  togglePlay(): void { this.isPlaying.update(v => !v); }
  toggleTranscript(): void { this.transcriptOpen.update(v => !v); }
  toggleLike(): void { this.isLiked.update(v => !v); }
}
